export const createFacilityViewState = (targetState: string, updateActions: string[]) => {
  return {
    $_FACILITY_VIEW: {
      on: {
        ON_CLOSE_FACILITY_FORM: {
          target: targetState,
        },
        ON_FACILITY_CREATED: {
          target: targetState,
          actions: updateActions,
        },
      },
    },
  };
};

export const onFacilityFormOpen = () => {
  return {
    ON_OPEN_FACILITY_FORM: {
      target: '$_FACILITY_VIEW',
    },
  };
};
